// 左侧导航
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { Layout, Menu, Icon } from 'antd';
const { SubMenu } = Menu;
const { Sider } = Layout;

export default class Left extends Component {
	static displayName = '左侧导航';
	static propTypes = {
		user: PropTypes.object,
	}

	constructor(props) {
		super(props);
	}

	render() {
		const { user } = this.props
		const defaultSelectedKeys = [];
		const defaultOpenKeys = [];

		const adminMenus = user.userMenus && user.userMenus['人力资源'] ? user.userMenus['人力资源'] : []
		const menuItems = adminMenus.map((userMenu) => {
			for (const i in userMenu["subModules"]) {
				if (userMenu["subModules"][i]["url"] === location.pathname) {
					defaultSelectedKeys.push(userMenu["subModules"][i]["id"].toString());
					defaultOpenKeys.push(userMenu["id"].toString());
				}
			}

			const subItems = userMenu["subModules"].map((subModule) => {
				return (
					<Menu.Item key={subModule["id"].toString()}><a href={subModule["url"]}>{subModule["moduleName"]}</a></Menu.Item>
				)
			});

			return (
				<SubMenu key={userMenu["id"].toString()} title={<span><Icon type={userMenu["icon"]} />{userMenu["moduleName"]}</span>}>
					{subItems}
				</SubMenu>
			);
		});
		return (

			<Sider width={184} style={{ background: '#fff' }}>
				<Menu
					mode="inline"
					defaultSelectedKeys={defaultSelectedKeys}
					defaultOpenKeys={defaultOpenKeys}
					style={{ height: '100%' }}
				>
					{menuItems}
				</Menu>
			</Sider>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/layout/left.js